import {
  CcfBox,
  CcfButton,
  CcfCloseIcon,
  CcfDeboucedInput,
  CcfPopOver,
  CcfTextField,
  CcfTypography,
  CcfUnavailableIcon,
  CcfUpArrowIcon,
  PopOverMenuItem,
} from '@nice-ccf/ui-controls';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import styles from './partner-access-control-table.module.scss';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
} from '@mui/material';
import { Search, Visibility, VisibilityOff } from '@mui/icons-material';

/* eslint-disable-next-line */
export interface PartnerAccessControlTableProps {
  allUserDetails: any;
  rowData: any;
  setRowData: any;
  uploadToS3: any;
  setRowDataCopy: any;
  rowDataCopy: any;
  setAllUserDetails: any;
  setShowToast: any;
  setShowToastMsg: any;
  errors: any;
  setErrors: any;
}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: '#333333',
    },
    '& .MuiOutlinedInput-input': {
      padding: '7px',
    },
  },
  searchInput: {
    '&.MuiOutlinedInput-input': {
      color: '#637A87',
      fontSize: '10px',
      padding: '5.5px 14px !important',
    },
    '&.MuiOutlinedInput-inputAdornedEnd': {
      paddingBottom: '7.5px',
    },
  },
  appHeaderDivider: {
    height: 'auto',
    borderColor: '#191c21 !important',
    opacity: '1',
    borderBottomWidth: '30px',
  },
});

/**
 * Component displays PartnerAccessControlTable
 * @param props -PartnerAccessControlTableProps
 * @returns app header component for landing screen
 * @example <PartnerAccessControlTable/>
 */
const ResetPasswordDialog = ({
  openPasswordDialog,
  setOpenPasswordDialog,
  handleResetPassword,
  selectedRowData,
  setNewPassword,
  newPassword,
  setConfirmNewPassword,
  confirmNewPassword,
  resetRows,
  passwordError,
  setPasswordError,
  errors,
  setErrors,
}: any) => {
  /**
   * method to trigger click event of resetPasswordDialogBox
   * @param item -resetPasswordDialogBox
   * @returns -
   * ```
   * @example
   * resetPasswordDialogBox
   * ```
   */
  const resetPasswordDialogBox = () => {
    setOpenPasswordDialog(false);
    setNewPassword('');
    setConfirmNewPassword('');
    resetRows();
  };

  return (
    <CcfBox>
      <Dialog
        onClose={resetPasswordDialogBox}
        open={openPasswordDialog}
        fullWidth={true}
      >
        <DialogTitle sx={{ fontWeight: '600' }}>{'Reset Password'}</DialogTitle>
        <DialogContent className={styles.passwordBlock}>
          <CcfBox className={styles.feildBlock}>
            <CcfTypography className={styles.tableHeaderText}>
              Current Password
            </CcfTypography>
            <CcfTextField
              id="currentPassword"
              variant="outlined"
              size="small"
              value={
                selectedRowData[0].password ? selectedRowData[0].password : ''
              }
              focused={false}
              style={{ width: '80%' }}
              InputProps={{
                className: styles.inputTxt,
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={styles.feildBlock}>
            <CcfTypography className={styles.tableHeaderText}>
              New Password
            </CcfTypography>
            <CcfTextField
              id="newPassword"
              variant="outlined"
              size="small"
              value={newPassword}
              focused={false}
              style={{ width: '80%' }}
              InputProps={{
                className: styles.inputTxt,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNewPassword(event?.target.value);
                let newErrors = { ...errors };
                if (event?.target.value.length < 6) {
                  newErrors = {
                    ...newErrors,
                    userName: event?.target.value.length < 6,
                  };
                  setErrors(newErrors);
                } else {
                  delete newErrors['userName'];

                  setErrors(newErrors);
                }
              }}
              error={
                (errors && errors['userName']) ||
                (selectedRowData &&
                  selectedRowData.length &&
                  selectedRowData[0] &&
                  Object.keys(selectedRowData[0]).length &&
                  selectedRowData[0].password &&
                  selectedRowData[0].password === newPassword)
              }
              helperText={
                errors['userName']
                  ? 'Must be at least 6 characters'
                  : selectedRowData &&
                    selectedRowData.length &&
                    selectedRowData[0] &&
                    Object.keys(selectedRowData[0]).length &&
                    selectedRowData[0].password &&
                    selectedRowData[0].password === newPassword
                  ? 'New password must differ from the previous one.'
                  : ''
              }
              FormHelperTextProps={{ style: { margin: '0' } }}
            />{' '}
          </CcfBox>
          <CcfBox className={styles.feildBlock}>
            <CcfTypography className={styles.tableHeaderText}>
              Confirm New Password
            </CcfTypography>
            <CcfTextField
              id="confirmPassword"
              variant="outlined"
              size="small"
              value={confirmNewPassword}
              focused={false}
              style={{ width: '80%' }}
              InputProps={{
                className: styles.inputTxt,
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setConfirmNewPassword(event?.target.value);
                setPasswordError(event?.target.value !== newPassword);
              }}
              error={passwordError}
              helperText={passwordError ? 'Password do not match' : ''}
              FormHelperTextProps={{ style: { margin: '0' } }}
            />{' '}
          </CcfBox>
        </DialogContent>
        <DialogActions className={styles.modalFooter}>
          <CcfButton className={styles.btn} onClick={resetPasswordDialogBox}>
            <CcfTypography className={styles.btnText}>Cancel</CcfTypography>
          </CcfButton>
          <CcfButton
            primary
            className={styles.btn}
            onClick={handleResetPassword}
            disabled={
              newPassword === '' ||
              confirmNewPassword === '' ||
              passwordError ||
              errors['userName'] ||
              (selectedRowData &&
                selectedRowData.length &&
                selectedRowData[0] &&
                Object.keys(selectedRowData[0]).length &&
                selectedRowData[0].password === newPassword)
            }
          >
            <CcfTypography className={styles.btnText}>
              Reset Password
            </CcfTypography>
          </CcfButton>
        </DialogActions>
      </Dialog>
    </CcfBox>
  );
};

/**
 * Component displays PartnerAccessControlTable
 * @param props -PartnerAccessControlTableProps
 * @returns app header component for landing screen
 * @example <PartnerAccessControlTable/>
 */
const DeleteDialogBox = ({
  openDeleteDialog,
  setOpenDeleteDialog,
  handleDeleteUser,
  selectedIds,
  resetRows,
}: any) => {
  /**
   * ```
   * @example
   * ```
   */
  const resetDeleteDialogBox = () => {
    setOpenDeleteDialog(false);
    resetRows();
  };

  return (
    <CcfBox>
      <Dialog
        onClose={resetDeleteDialogBox}
        open={openDeleteDialog}
        fullWidth={true}
      >
        <DialogTitle sx={{ fontWeight: '600' }}>
          {selectedIds && selectedIds.length > 1
            ? 'Delete Partner Users'
            : 'Delete Partner User'}
        </DialogTitle>
        <DialogContent className={styles.passwordBlock}>
          <CcfBox className={styles.feildBlock}>
            <DialogContentText id="delete-user-dialog-description">
              <CcfTypography>
                {`Are you sure you want to delete the selected ${
                  selectedIds && selectedIds.length > 1 ? 'users' : 'user'
                }?`}
              </CcfTypography>
            </DialogContentText>
          </CcfBox>
        </DialogContent>
        <DialogActions className={styles.modalFooter}>
          <CcfButton className={styles.btn} onClick={resetDeleteDialogBox}>
            <CcfTypography className={styles.btnText}>No</CcfTypography>
          </CcfButton>
          <CcfButton primary className={styles.btn} onClick={handleDeleteUser}>
            <CcfTypography className={styles.btnText}>Yes</CcfTypography>
          </CcfButton>
        </DialogActions>
      </Dialog>
    </CcfBox>
  );
};

/**
 * Component displays PartnerAccessControlTable
 * @param props -PartnerAccessControlTableProps
 * @returns app header component for landing screen
 * @example <PartnerAccessControlTable/>
 */
export function PartnerAccessControlTable(
  props: PartnerAccessControlTableProps
) {
  const {
    allUserDetails,
    rowData,
    setRowData,
    uploadToS3,
    rowDataCopy,
    setAllUserDetails,
    setShowToast,
    setShowToastMsg,
    errors,
    setErrors,
    setRowDataCopy,
  } = props;
  const classes = useStyles();
  const [selectedIds, setSelectedIds]: any = useState([]);
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog]: any = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [deletedRow, setDeletedRow]: any = useState();
  const [operationPerform, setOperationPerform]: any = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [selectedRowData, setSelectedRowData]: any = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const rowsPerPageOptions = [10, 20, 30];
  const [pageSize, setPageSize] = useState(rowsPerPageOptions[0]);

  /**
   * Component displays PartnerAccessControlTable
   * @param props -PartnerAccessControlTableProps
   * @returns app header component for landing screen
   * @example <PartnerAccessControlTable/>
   */
  const PasswordCell = (e: any) => {
    const { value } = e;
    const [visible, setVisible] = useState(false);

    /**
     * Component displays PartnerAccessControlTable
     * @param props -PartnerAccessControlTableProps
     * @returns app header component for landing screen
     * @example <PartnerAccessControlTable/>
     */
    const toggleVisibility = (event:any) => {
      event.stopPropagation();
      setVisible(!visible);
    };

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '80%',
          justifyContent: 'space-between',
        }}
      >
        <span>{visible ? value : '*'.repeat(value.length)}</span>
        <IconButton onClick={toggleVisibility} style={{ marginLeft: '5px' }}>
          {visible ? (
            <VisibilityOff style={{ fontSize: '1.1rem' }} />
          ) : (
            <Visibility style={{ fontSize: '1.1rem' }} />
          )}
        </IconButton>
      </div>
    );
  };

  const dropdownOptions = {
    menuItems: [
      {
        items: [
          {
            label: 'Active',
            closeOnSelection: true,
          },
          {
            label: 'Inactive',
            closeOnSelection: true,
          },
          {
            label: 'Reset P/W',
            closeOnSelection: true,
          },
          {
            label: 'Delete User',
            closeOnSelection: true,
          },
        ],
      },
    ],
  };

  const allColumns = [
    {
      field: 'name',
      headerName: 'name'.toUpperCase(),
      hide: false,
      flex: 1,
      maxWidth: 270,
    },
    {
      field: 'userName',
      headerName: 'userName'.toUpperCase(),
      flex: 1,
      maxWidth: 270,
      hide: false,
      cellClassName: 'cell-firstName',
    },
    {
      field: 'state',
      headerName: 'state'.toUpperCase(),
      maxWidth: 230,
      flex: 1,
      renderCell: (params: any) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            width: 'auto',
          }}
        >
          <div id="agent_interactionSearcg_skill_popoverMenu">
            {params.value === 'Active' ? (
              <CheckCircleOutlineOutlinedIcon
                style={{ fontSize: '1.1rem', fill: 'green' }}
              />
            ) : (
              <CcfUnavailableIcon
                // className="iconUnavailable"
                fontSize="small"
                viewBox="0 0 22 22"
                style={{ fontSize: '1.1rem', marginLeft: '-1px' }}
              />
            )}
          </div>

          {params.value}
        </div>
      ),
      hide: false,
    },
    {
      field: 'password',
      headerName: 'password'.toUpperCase(),
      maxWidth: 250,
      flex: 1,
      renderCell: (params: any) => <PasswordCell value={params.value} />,
      hide: false,
    },
    {
      field: 'actions',
      headerName: 'actions'.toUpperCase(),
      flex: 1,
      maxWidth: 280,
      renderCell: (params: any) => {
        // Filter the dropdown options based on the row state
        const filteredDropdownOptions = {
          ...dropdownOptions,
          menuItems: [
            {
              ...dropdownOptions.menuItems[0],
              items: dropdownOptions.menuItems[0].items.filter((item: any) => {
                return params.row.state !== item.label;
              }),
            },
          ],
        };

        return (
          <div
            style={{ margin: '0px 20px' }}
            id="partneraccess_skill_popoverMenu"
          >
            <CcfPopOver
              onPopOverItemSelection={onPopOverItemSelection}
              optionList={filteredDropdownOptions}
            />
          </div>
        );
      },
      hide: false,
    },
  ];

  /**
   * method to trigger click event of popover menuitem
   * @param item -PopOverMenuItem
   * @returns -
   * ```
   * @example
   * onPopOverItemSelection('Show Origin')
   * ```
   */
  const handleSelectionChange = (ids: any) => {
    const selectedIDs = ids;
    const selectedData = rowData.filter((row: any) =>
      selectedIDs.some((x: any) => x === row.id)
    );
    setSelectedRowData(selectedData);
    setSelectedIds(ids);
  };

  /**
   * method to trigger click event of resetRows
   * @param item -resetRows
   * @returns -
   * ```
   * @example
   * resetRows
   * ```
   */
  const resetRows = () => {
    setSelectedIds([]);
    setSelectedRowData([]);
  };

  /**
   * method to trigger click event of handleUpdateState
   * @param item -handleUpdateState
   * @returns -
   * ```
   * @example
   * handleUpdateState('Show Origin')
   * ```
   */
  const handleUpdateState = (label: any, type: any) => {
    const allUsers = JSON.parse(JSON.stringify(allUserDetails));
    const allUserRowData = JSON.parse(JSON.stringify(rowDataCopy));
    const index = allUsers.findIndex((f: any) => f.id === selectedIds[0]);
    const updatedS3Data = [...allUsers];
    const updatedRowData = [...allUserRowData];
    if (
      index !== -1 &&
      selectedIds &&
      selectedIds.length &&
      type === 'single'
    ) {
      updatedS3Data[index] = {
        ...allUsers[index],
        state: label,
      };

      const d = updatedRowData.map((x: any) =>
        x.id === selectedIds[0] ? { ...x, state: label } : x
      );
      setRowData(d);
      setRowDataCopy(d);
      setSelectedState('');
      setSearchTerm('');
      setAllUserDetails(updatedS3Data);
      uploadToS3(updatedS3Data);
      resetRows();
      setShowToast(true);
      setShowToastMsg(
        `The Selected user's state has successfully changed to ${label}.`
      );
    } else if (selectedIds && selectedIds.length && type === 'multiple') {
      const s3Data = updatedS3Data.map((row: any) => {
        if (selectedIds && selectedIds.includes(row.id)) {
          return { ...row, state: label };
        }
        return row;
      });
      const d = updatedRowData.map((x: any) => {
        if (selectedIds && selectedIds.includes(x.id)) {
          return { ...x, state: label };
        }
        return x;
      });
      setRowData(d);
      setRowDataCopy(d);
      setSelectedState('');
      setSearchTerm('');
      setAllUserDetails(s3Data);
      uploadToS3(s3Data);
      resetRows();
      setShowToast(true);
      setShowToastMsg(
        `The Selected user's state has successfully changed to ${label}.`
      );
    }
  };

  /**
   * method to trigger click event of handleDeleteUser
   * @param item -handleDeleteUser
   * @returns -
   * ```
   * @example
   * handleDeleteUser('Show Origin')
   * ```
   */
  const handleDeleteUser = () => {
    const allUsers = JSON.parse(JSON.stringify([...allUserDetails]));
    const allUserRowData = [...rowDataCopy];
    if (selectedIds && selectedIds.length) {
      const updatedS3Data = allUsers.filter(
        (x: any) => !selectedIds.includes(x.id)
      );

      const updatedRowData = allUserRowData.filter(
        (x: any) => !selectedIds.includes(x.id)
      );

      setRowData(updatedRowData);
      setRowDataCopy(updatedRowData);
      setSelectedState('');
      setSearchTerm('');
      setAllUserDetails(updatedS3Data);
      uploadToS3(updatedS3Data);
      setDeletedRow(selectedIds[0]);
      resetRows();
      setOpenDeleteDialog(false);
      setShowToast(true);
      setShowToastMsg(`The selected user has been successfully deleted.`);
    }
  };
  /**
   * method to trigger click event of popover menuitem
   * @param item -PopOverMenuItem
   * @returns -
   * ```
   * @example
   * onPopOverItemSelection('Show Origin')
   * ```
   */
  const onPopOverItemSelection = (item: PopOverMenuItem) => () => {
    if (selectedIds && selectedIds.length) {
      setOperationPerform(item.label);
      const allUsers = JSON.parse(JSON.stringify(allUserDetails));
      const index = allUsers.findIndex((f: any) => f.id === selectedIds[0]);
      if (index !== -1) {
        if (item.label === 'Active' || item.label === 'Inactive') {
          handleUpdateState(item.label, 'single');
        } else if (item.label === 'Delete User') {
          setOpenDeleteDialog(true);
          // handleDeleteUser();
        } else if (item.label === 'Reset P/W') {
          setOpenPasswordDialog(true);
        }
      }
    }
  };

  /**
   * method to trigger click event of handleResetPassword
   * @param item -handleResetPassword
   * @returns -
   * ```
   * @example
   * handleResetPassword
   * ```
   */
  const handleResetPassword = () => {
    const allUsers = JSON.parse(JSON.stringify(allUserDetails));
    const allUserRowData = JSON.parse(JSON.stringify(rowDataCopy));
    const index = allUsers.findIndex((f: any) => f.id === selectedIds[0]);
    const updatedS3Data = [...allUsers];
    const updatedRowData = [...allUserRowData];
    updatedS3Data[index] = {
      ...allUsers[index],
      password: newPassword,
    };

    const d = updatedRowData.map((x: any) =>
      x.id === selectedIds[0] ? { ...x, password: newPassword } : x
    );
    // updatedRowData[index] = {
    //   ...allUserRowData[index],
    //   password: newPassword,
    // };

    setRowData(d);
    setRowDataCopy(d);
    setSelectedState('');
    setSearchTerm('');
    setAllUserDetails(updatedS3Data);
    uploadToS3(updatedS3Data);
    setOpenPasswordDialog(false);
    setNewPassword('');
    setConfirmNewPassword('');
    resetRows();
    setShowToast(true);
    setShowToastMsg(
      `The new password for the selected user has been updated successfully.`
    );
  };

  /**
   * @example
   * filterData
   */
  const filterData = () => {
    let filteredData = JSON.parse(JSON.stringify([...rowDataCopy]));
    if (searchTerm) {
      filteredData = filteredData.filter(
        (row: any) =>
          row.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          row.userName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedState) {
      filteredData = filteredData.filter(
        (row: any) => row.state === selectedState
      );
    }
    setRowData(filteredData);
  };
  // Use useEffect to apply filters when searchTerm or selectedState changes
  useEffect(() => {
    filterData();
  }, [searchTerm, selectedState]);

  /**
   * @example
   * handleSearchChange
   */
  const handleSearchChange = (event: any) => {
    setSearchTerm(event.target.value);
  };

  /**
   * @example
   * handleStateChange
   */
  const handleStateChange = (event: any) => {
    setSelectedState(event.target.value);
  };

  return (
    <CcfBox id="partnerAccessTableContainer">
      <CcfBox className={styles.tableBlock}>
        <CcfBox className={styles.tableHeader}>
          <CcfBox className={styles.subHeader}>
            <CcfBox className={styles.tableHeaderTextBlock}>
              <CcfTypography
                id="partnerAccessCount"
                className={styles.tableHeaderText}
              >
                {rowData.length} Partner Users
              </CcfTypography>
              <Divider
                style={{
                  height: '20px',
                  width: '1px',
                  background: '#E5E5E5',
                }}
              />
              <CcfTypography
                id="partnerAccessSelectedCount"
                className={styles.tableHeaderText}
              >
                {' '}
                {selectedIds.length} Selected
              </CcfTypography>
            </CcfBox>
            <CcfBox
              id="partnerAccessSearchContainer"
              className={styles.searchBoxSection}
            >
              <CcfBox className={styles.searchBox}>
                <CcfTextField
                  id="partnerAccessSearch"
                  size="small"
                  style={{
                    background: 'white',
                  }}
                  className={styles.searchInput}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Search htmlColor="grey" />
                      </InputAdornment>
                    ),
                  }}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder="Start typing to find user"
                  variant="outlined"
                  fullWidth
                />
              </CcfBox>
            </CcfBox>

            <CcfBox className={styles.selectParent}>
              {/* <CcfTypography className={styles.tableHeaderText}>
                Select State
              </CcfTypography> */}
              <FormControl
                fullWidth
                variant="outlined"
                // className={classes.formControl}
                style={{
                  width: '100%',
                  marginBottom: '7px',
                }}
              >
                <InputLabel>Select State</InputLabel>
                <Select
                  id="partnerAccessSelectDropdown"
                  className={styles.customDropdown}
                  label="Select State"
                  classes={{ root: classes.root }}
                  onChange={handleStateChange}
                  value={selectedState || ''}
                  IconComponent={() =>
                    selectedState ? (
                      <CcfCloseIcon
                        className={styles.attachmentCloseIcon}
                        onClick={() => {
                          setSelectedState('');
                          setSearchTerm('');
                          const copy = [...rowDataCopy];
                          if (operationPerform === 'Delete User') {
                            const updatedRowDataCopy = copy.filter(
                              (copyItem: any) => deletedRow !== copyItem.id
                            );

                            setRowDataCopy(updatedRowDataCopy);
                          } else if (
                            operationPerform === 'Active' ||
                            operationPerform === 'Inactive'
                          ) {
                            rowDataCopy.forEach((f: any) => {
                              const changeRow = rowData.filter(
                                (row: any) => row.name === f.name
                              );

                              const i = copy.findIndex(
                                (i: any) =>
                                  changeRow &&
                                  changeRow.length &&
                                  changeRow[0] &&
                                  Object.keys(changeRow[0]).length &&
                                  changeRow[0].id &&
                                  i.id === changeRow[0].id
                              );

                              if (i !== -1) {
                                copy[i] = { ...changeRow[0] };
                              }
                            });
                            // setRowData(copy);
                            setRowDataCopy(copy);
                          } else {
                            setRowData(copy);
                          }
                        }}
                      />
                    ) : (
                      <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
                    )
                  }
                >
                  <MenuItem
                    classes={{
                      root: styles.dropdownOption,
                    }}
                    value="Active"
                    id="partnerAccessActiveDropdown"
                  >
                    Active
                  </MenuItem>
                  <MenuItem
                    classes={{
                      root: styles.dropdownOption,
                    }}
                    value="Inactive"
                    id="partnerAccessDeactiveDropdown"
                  >
                    Inactive
                  </MenuItem>
                </Select>{' '}
              </FormControl>
            </CcfBox>
          </CcfBox>
          {selectedIds && selectedIds.length > 0 && (
            <CcfBox
              style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              {selectedState && selectedState.length > 0 && (
                <CcfButton
                  style={{
                    color: '#007CBE',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    padding: '2px 10px',
                  }}
                  onClick={() => {
                    const label =
                      selectedState === 'Active' ? 'Inactive' : 'Active';
                    setOperationPerform(label);
                    handleUpdateState(label, 'multiple');
                  }}
                  id="partnerAccessChangeStateButton"
                >
                  {selectedState === 'Active' ? 'Inactive' : 'Active'}
                </CcfButton>
              )}
              {selectedIds && selectedIds.length === 1 && (
                <CcfButton
                  style={{
                    color: '#007CBE',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    padding: '2px 10px',
                  }}
                  onClick={() => {
                    setOpenPasswordDialog(true);
                    setOperationPerform('Reset P/W');
                  }}
                  id="partnerAccessResetPasswordButton"
                >
                  Reset P/W
                </CcfButton>
              )}
              <CcfButton
                style={{
                  color: '#007CBE',
                  fontWeight: 'bold',
                  fontSize: '13px',
                  padding: '2px 10px',
                }}
                onClick={() => {
                  setOperationPerform('Delete User');
                  setOpenDeleteDialog(true);
                  // handleDeleteUser();
                }}
                id="partnerAccessDeleteUserButton"
              >
                Delete User
              </CcfButton>
            </CcfBox>
          )}
        </CcfBox>
        <CcfBox style={{ height: '70vh', overflowY: 'scroll' }}>
          <CcfBox
            style={{
              height: 'inherit',
              backgroundColor: '#FFFF',
              overflowY: 'hidden',
              border: '1px solid #E1E1E1',
            }}
            id="partnerAccessDataGridContainer"
          >
            {' '}
            <DataGrid
              classes={{ root: classes.root }}
              rows={rowData}
              columns={allColumns}
              rowHeight={40}
              getRowId={(row) => row?.id}
              headerHeight={40}
              // disableSelectionOnClick
              checkboxSelection
              onSelectionModelChange={handleSelectionChange}
              selectionModel={selectedIds}
              pageSize={pageSize}
              pagination
              rowsPerPageOptions={rowsPerPageOptions}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              getRowClassName={(params: any) => `styledrows`}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  color: '#3F5C69',
                  fontWeight: '600',
                  fontSize: '12px',
                  fontFamily: 'Open Sans',
                },
              }}
            />
          </CcfBox>
        </CcfBox>
      </CcfBox>

      {selectedIds && selectedIds.length > 0 && (
        <ResetPasswordDialog
          openPasswordDialog={openPasswordDialog}
          setOpenPasswordDialog={setOpenPasswordDialog}
          handleResetPassword={handleResetPassword}
          selectedRowData={selectedRowData}
          setNewPassword={setNewPassword}
          newPassword={newPassword}
          resetRows={resetRows}
          confirmNewPassword={confirmNewPassword}
          setConfirmNewPassword={setConfirmNewPassword}
          passwordError={passwordError}
          setPasswordError={setPasswordError}
          errors={errors}
          setErrors={setErrors}
        />
      )}
      {openDeleteDialog && (
        <DeleteDialogBox
          openDeleteDialog={openDeleteDialog}
          setOpenDeleteDialog={setOpenDeleteDialog}
          handleDeleteUser={handleDeleteUser}
          selectedRowData={selectedRowData}
          resetRows={resetRows}
          selectedIds={selectedIds}
        />
      )}
    </CcfBox>
  );
}

export default PartnerAccessControlTable;
